import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Tooltip, Typography } from '@mui/material';
import { TAGS_METADATA } from '@features/powerpoint';

const getExampleText = (tag: string) => `<${tag}>Example text</${tag}>`;

const TooltipContent = () => {
  return (
    <Stack direction="column" spacing={2}>
      <Typography>
        You may enclose any text in the following tags to apply styles to the
        generated document:
      </Typography>
      <Stack direction="column" spacing={1}>
        {TAGS_METADATA.map(tagInfo => (
          <Typography key={tagInfo.tag}>
            {getExampleText(tagInfo.tag)} {tagInfo.description}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export const TagsInfoIcon = () => {
  return (
    <Tooltip title={<TooltipContent />} placement="top" arrow>
      <FontAwesomeIcon icon={faInfoCircle} />
    </Tooltip>
  );
};
